import { Stack, Typography } from '@prenuvo/halo';

import { isEmpty } from '@/shared/util';

import { usePreviousStudies } from '../../../../../hook';
import { usePatientDocs } from '../use-patient-docs.hook';
import { DocumentsByStudy } from './documents-by-study.component';
import { PreviousStudiesDocs } from './previous-studies-docs.component';

export function PatientDocsList() {
  const { currentStudyDocs } = usePatientDocs();
  const { hasPreviousStudyResults } = usePreviousStudies();

  const show = {
    empty: isEmpty(currentStudyDocs) && !hasPreviousStudyResults,
  };

  if (show.empty) {
    return (
      <Stack
        alignment="center"
        className="w-full rounded-lg border border-neutral-600 p-6"
        gap={0}
        variant="vertical"
      >
        <Typography
          translationKey="FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENTS.EMPTY"
          variant="paragraph-sm-bold"
        />
      </Stack>
    );
  }

  return (
    <>
      {currentStudyDocs && (
        <DocumentsByStudy
          documents={currentStudyDocs?.documents ?? []}
          mhsLink={currentStudyDocs?.mhsLink}
          study={currentStudyDocs?.study}
        />
      )}

      {hasPreviousStudyResults && <PreviousStudiesDocs />}
    </>
  );
}
